<template>
  <div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="500px"
      append-to-body
      :before-close="handleClose"
      custom-class="modifyTheUserPassword"
    >
      <div>
<!--        <svg-icon-->
<!--          icon-class="logoComplete"-->
<!--          class="logoComplete"-->
<!--        />-->
        <el-form ref="formLabelAlign" label-position="right" :rules="rules" label-width="140px" :model="formLabelAlign">
          <el-form-item label="旧   密   码：" class="oldPass" prop="oldPass">
            <el-input v-model="formLabelAlign.oldPass" :type="formLabelAlignEye.oldPass?'':'password'" autocomplete="off">
              <svg-icon
                slot="suffix"
                :icon-class="formLabelAlignEye.oldPass ? 'blink' : 'closedEyes'"
                @click.stop="showView('oldPass')"
              />
            </el-input>
          </el-form-item>
          <el-form-item label="新   密   码：" class="newPass" prop="newPass">
            <el-input v-model="formLabelAlign.newPass" :type="formLabelAlignEye.newPass?'':'password'" autocomplete="off">
              <svg-icon
                slot="suffix"
                :icon-class="formLabelAlignEye.newPass ? 'blink' : 'closedEyes'"
                @click.stop="showView('newPass')"
              />
            </el-input>
          </el-form-item>
          <el-form-item label="确认新密码：" prop="newPass2">
            <el-input v-model="formLabelAlign.newPass2" :type="formLabelAlignEye.newPass2?'':'password'" autocomplete="off">
              <svg-icon
                slot="suffix"
                :icon-class="formLabelAlignEye.newPass2 ? 'blink' : 'closedEyes'"
                @click.stop="showView('newPass2')"
              />
            </el-input>
          </el-form-item>
        </el-form></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updatePass } from '@/api/system/code'
export default {
  name: 'DIMAIOTPlatformOpWebIndex',

  data() {
    return {
      dialogVisible: false,
      formLabelAlign: {},
      formLabelAlignEye: {
        oldPass: false,
        newPass: false,
        newPass2: false
      },
      rules: {
        oldPass: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPass: [
          { required: true, validator: this.validatePass, trigger: 'change' }
        ],
        newPass2: [
          { required: true, validator: this.validatePass2, trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    dialogVisible() {
      if (!this.dialogVisible) {
        this.formLabelAlign = {}
        this.$refs.formLabelAlign.clearValidate()
        this.formLabelAlignEye = {
          oldPass: false,
          newPass: false,
          newPass2: false
        }
      }
    }
  },

  mounted() {
  },
  methods: {
    showView(i) {
      this.formLabelAlignEye[i] = !this.formLabelAlignEye[i]
    },
    handleClose() {
      this.dialogVisible = false
    },
    validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formLabelAlign.newPass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formLabelAlign.newPass !== '') {
          this.$refs.formLabelAlign.validateField('checkPass')
        }
        callback()
      }
    },
    submitForm() {
      this.$refs['formLabelAlign'].validate((valid) => {
        if (valid) {
          updatePass(this.formLabelAlign).then((result) => {
            this.$notify({
              title: '成功',
              message: '密码修改成功，请重新登陆',
              type: 'success'
            })
            this.$store.dispatch('LogOut').then(() => {
              location.reload()
            })
          }).catch((err) => {
            console.log(err.response.data.message)
            if (!err.response.data.message.includes('旧密码错误')) {
              this.$message.error(`数据错误，请联系管理员，${err}`)
            }
          })
        } else {
          return false
        }
      })
    }

  }
}
</script>

<style lang="scss">
.modifyTheUserPassword{
    height: 440px;
    .el-dialog__header{
        padding: 27px 30px 0 41px;
        color: rgba(25, 31, 38, 1);
        letter-spacing: 1px;
        font-size: 16px;
        .el-dialog__headerbtn{
            top: auto;
            right: 30px;
        }
    }
    .oldPass,.newPass{
        letter-spacing: 3px;
    }
    .el-input{
        width: 250px;
    }
    .el-button{
        padding-top: 0;
        padding-bottom: 0;
        width: 82px;
        height: 32px;
        letter-spacing: 2px;
        font-size: 16px;
        line-height: 20px;
    }
    .el-button+.el-button{
        margin-left: 48px;
    }
    .el-dialog__footer{
        text-align: center;
    }
    .logoComplete{
        width: 360px !important;
        height: 70px !important;
        margin-bottom: 27px;
    }
}
</style>
